module.exports = __webpack_public_path__ + "img/keble-college-oxford.694ee7db.jpg";